<template>
	<div
		class="search-component"
		:class="{ 'with-search-list': showSearchList }"
	>
		<InputRichDropdown
			v-if="showSearchList"
			v-model:saturn="toSearch"
			:list="[{ key: 'all', label: 'All' }, ...searchKeys]"
			:valueMap="d => d.key"
			:display="d => d.label"
		/>

		<InputTextbox
			:height="35"
			:showIcon="false"
			v-model:saturn="searchValue"
			:clearable="true"
			@cleared="resetTextHandler"
			@keyEnter="filterResultsDown"
			@change="() => util.debounce(handleSearchInputChange, 250)"
		/>

		<button @click="filterResultsDown">Search</button>
	</div>
</template>

<script>
	import InputRichDropdown from '@core/components/InputRichDropdown.vue';
	import InputTextbox from '@core/components/InputTextbox.vue';
	import util from '@core/services/util';

	export default {
		name: 'SearchComponent',
		emits: ['onSearch', 'update:output'],
		props: ['searchKeys', 'data', 'output', 'searchByFilter', 'tableRow', 'instantSearch'],
		data() {
			return {
				toSearch: 'all',
				searchValue: null,
			};
		},
		computed: {
			showSearchList() {
				return this.searchKeys && this.searchKeys.length != 0;
			},
			util() {
				return util;
			},
		},
		created() {
			this.$emit('update:output', this.data);

			if (!(this.searchKeys || this.searchByFilter)) {
				throw 'SearchComponent missing searchKeys or searchByFilter Props';
			} else if (this.searchKeys && this.searchByFilter) {
				console.warn('SearchComponent has both searchKeys and searchByFilter Props. Only one will be used (searchKeys).');
			}

			this.EventBus.on('SearchComponent_Reset', this.resetTextHandler);
		},
		beforeUnmount() {
			this.EventBus.off('SearchComponent_Reset', this.resetTextHandler);
		},

		methods: {
			handleSearchInputChange() {
				if (this.instantSearch) {
					this.filterResultsDown();
				}
			},
			resetTextHandler() {
				this.searchValue = '';
				this.filterResultsDown();
			},
			filterResultsDown() {
				let output2 = [];

				//PRIMARY FILTER FUNCTION
				let outputFilterFunction = (row, searchKey) => {
					let value = searchKey.value ? searchKey.value(row) : row[searchKey.key];
					return row && value && value.toString().toLowerCase().includes(this.searchValue.toLowerCase());
				};

				if (this.searchValue) {
					if (this.searchKeys) {
						if (this.toSearch == 'all') {
							output2 = this.data.filter(d => d && this.searchKeys.some(sK => outputFilterFunction(d, sK)));
						} else {
							let searchKey = this.searchKeys.find(sK => sK.key == this.toSearch);
							output2 = this.data.filter(d => outputFilterFunction(d, searchKey));
						}
					} else if (this.searchByFilter) {
						output2 = this.data.filter(d => d && this.searchByFilter(d, this.searchValue));
					}
				} else {
					output2 = this.data;
				}

				this.$emit('update:output', output2);
				this.$emit('onSearch');
			},
		},
		components: {
			InputTextbox,
			InputRichDropdown,
		},
	};
</script>
<style>
	.search-component {
		display: flex;
		align-items: center;
		gap: 5px;
	}

	.search-component .reset-text {
		padding: 7px 9px;
		font-size: 16px;
		-webkit-text-stroke-color: var(--disabled-color);
		-webkit-text-stroke-width: 1px;
		color: var(--background-color);
		margin-top: -1px;
		margin-right: -1px;
	}

	.search-component .reset-text:hover {
		cursor: pointer;
		-webkit-text-stroke-width: 0;
		color: var(--background-color);
		text-shadow: 0 0 3px var(--black-30percent);
		background: var(--disabled-color);
	}

	.search-component button {
		width: auto;
		border-top-right-radius: 3px;
		border-bottom-right-radius: 3px;
	}

	.search-component:not(:has(.InputRichDropdown)) .input-component-wrapper {
		position: relative;
		left: 6px;
	}

	.search-component:not(:has(.InputRichDropdown)) .input-component .saturn-textbox.search-input fieldset.floatingLabel {
		border-top-right-radius: unset;
		border-bottom-right-radius: unset;
		border-right: none;
	}

	.search-component:not(:has(.InputRichDropdown)) .input-component .saturn-textbox select {
		padding: 5px 35px 5px 15px;
	}
</style>
